import type { APIEarnedAchievement } from "@rosette/ts/src/business/api/api_schema.js";
import { AchievementType } from "@rosette/ts/src/business/achievement/AchievementType.js";
import type { ToastOptions } from "@rosette/web_components/feedback/toast/ToastContext.js";
import type { AchievementResources } from "@/components/achievements/AchievementResources.js";
import { addAchievementToast } from "@/components/achievements/addAchievementToast.js";


export function addEarnedAchievementToasts(
    earnedAchievements: APIEarnedAchievement[],
    addToast: (toast: ToastOptions) => void,
    achievementResources: AchievementResources,
): void {
    for (const earned of earnedAchievements) {
        if (!earned.should_notify)
            continue;

        const achievementType = AchievementType.getByID(earned.achievement_id);
        addAchievementToast(achievementType, addToast, achievementResources);
    }
}
